import swal from "sweetalert2";
import moment from "moment";
import React from "react";

/* eslint-disable */
export const regexMobile = /^(09|\+639)\d{9}$/;
export const regexEmail =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const browserLogs = (obj) => {
  //console.clear();
  console.log("===========================================\n", obj);
};

export const toast = (title, text, icon) =>
  swal.fire({
    title,
    text,
    icon,
  });

export const confirm = (title, confirmButtonText) =>
  swal.fire({
    title,
    showCancelButton: true,
    confirmButtonText,
  });

export const toastRPT = (proceed) => {
  swal.fire({
    text: "Input Tax Declaration No.",
    input: "text",
    inputAttributes: {
      autocapitalize: "off",
    },
    showCancelButton: true,
    confirmButtonText: "Search",
    showLoaderOnConfirm: true,
    preConfirm: (value) => proceed(value),
    allowOutsideClick: () => !swal.isLoading(),
  });
};

export const currencyFormat = (value) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const currency = formatter.format(value);
  return currency.replace("$", "");
};

export const rptKind = (kind) => {
  switch (kind.toLowerCase()) {
    case "l":
      return "Land";
    case "b":
    case "i":
      return "Building";
    case "m":
      return "Machinery";
    default:
      return "";
  }
};

export const rptActualUse = (au) => {
  switch (au.toLowerCase().substr(0, 3)) {
    case "res":
      return "Residential";
    case "com":
      return "Commercial";
    case "ind":
      return "Industrial";
    case "spe":
      return "Special";
    default:
      return au;
  }
};

export const quarter = (month) =>
  month >= 1 && month <= 3
    ? 1
    : month >= 4 && month <= 6
    ? 2
    : month >= 7 && month <= 9
    ? 3
    : 4;

export const rptYear = (last_payment, effectivity) =>
  last_payment
    ? parseInt(last_payment.split(" ")[0]) +
      (parseInt(last_payment.split(" ")[3]) === 4 ? 1 : 0)
    : moment(new Date(effectivity)).format("YYYY");

export const rptQtr = (last_payment, effectivity) =>
  last_payment
    ? parseInt(last_payment.split(" ")[3]) === 4
      ? 1
      : parseInt(last_payment.split(" ")[3]) + 1
    : quarter(parseInt(moment(new Date(effectivity)).format("MM")));

export const policyNote = () => (
  <p className="text-justify">
    "I hereby authorize the City Government of Parañaque to collect and process
    the data indicated in this form, I understand that my personal information
    is protected by R.A. No. 10173 - <em>"Data Privacy Act of 2012"</em> and
    that I am required to provide truthful information in processing my
    application with regard to payment of Local Government taxes, dues, and
    fees."
  </p>
);
